import React, { useEffect, useState } from 'react'
import Pagination from './Pagination'

const Pager = () => {
    const [page, setPage] = useState(1)
    const pages = 12

    useEffect(() => {
        
    },[page])
  return (
      <div className='flex flex-col w-full min-h-screen items-center justify-center p-5'>
       <Pagination page={page} setPage={setPage} hasNextPage={page<pages} />
          <Pagination
              page={page}
              setPage={setPage}
              pages={pages}
              hasNextPage={page < pages} />
    </div>
  )
}

export default Pager